import React from 'react';

export default function Component(props) {

const { question, answersList, ansNPSInput, surveyLanguageCode, surveyScreenData } = props;
  let [showValue, handleValue ] = React.useState(false)

function CustomLabels(optionID,optionName, question){
  let surveyLanguageCode = "customNPS";
  return  (surveyLanguageCode!=='')?
  (question && question.transl && 
    question.transl[surveyLanguageCode] && 
        question.transl[surveyLanguageCode][optionID])?
          question.transl[surveyLanguageCode][optionID]:optionName
  :optionName
}

  


function NPSColor(question){

  function NPSName(optionID, optionName, surveyLanguageCode, question){
    return  (surveyLanguageCode!=='')?
    (question && question.transl && 
      question.transl[surveyLanguageCode] && 
        question.transl[surveyLanguageCode].optionsList && 
          question.transl[surveyLanguageCode].optionsList[optionID])?
            question.transl[surveyLanguageCode].optionsList[optionID]:optionName
    :optionName
  }

  // CustomLabels("Ratehere", "Rate here",question);

  let Color = "#a3a3a3";
  let Name = NPSName("Ratehere", CustomLabels("Ratehere", "Rate here",question), surveyLanguageCode, question)
  let answer = parseInt(answersList[answersList.findIndex(item => item.questionId === question.id)].answer);
  if(showValue || showValue===0){
    answer = showValue;
  }

  
  if(answer === 0 || answer === 1 || answer === 2 || answer === 3 || answer === 4 || answer === 5 || answer === 6 ){
    // Color = "#ed3e34";
    if(answer === 0 || answer === 1 || answer === 2){
      Name = NPSName("Extremelydissatisfied", CustomLabels("Extremelydissatisfied", "Extremely dissatisfied",question) , surveyLanguageCode, question)
      Color = "#ed3e34";
    }
    else if(answer === 3 || answer === 4){
      Name = NPSName("Dissatisfied", CustomLabels("Dissatisfied", "Dissatisfied",question) , surveyLanguageCode, question)
      console.log('Dissatisfied Name: ',Name)
      Color = "#ed3e34";
    }
    else if(answer === 5 || answer === 6){
      Name = NPSName("Neither",CustomLabels("Neither", "Neither",question), surveyLanguageCode, question)
      Color = "#fcb817";

    }
  }
  else if(answer === 7 || answer === 8){
    Color = "#0acc4b";
    Name = NPSName("Satisfied", CustomLabels("Satisfied", "Satisfied",question), surveyLanguageCode, question)
  }
  else if(answer === 9 || answer === 10){
    Color = "#0acc4b";
    Name = NPSName("Extremelysatisfied",  CustomLabels("Extremelysatisfied", "Extremely satisfied",question) , surveyLanguageCode, question)
  }

  return {
    color:Color,
    name:Name
  }
}


console.log("question=========>",question)




return(
    <>
          <div className="grid grid-cols-11 gap-4 py-6  lg:text-lg text-sm mx-2">
            {/* 1 */}
            {[...Array(11).keys()].map((value,index)=>
            <>
            {((value).toString()===answersList[answersList.findIndex(item => item.questionId === question.id)].answer)?

              <span onMouseEnter={()=>handleValue((value))}  onClick={()=>ansNPSInput((value).toString(),question)} key={index} 
              style={{background:NPSColor(question,surveyLanguageCode).color}} 
              className="bg-gray-100 rounded-md md:p-4 md:py-4 p-4 py-2 text-white  flex items-center justify-center  hover:bg-red-400  font-medium  cursor-pointer   px-3">
              {value}
              </span>

              :
            <>
            {(value) <= (showValue || parseInt(answersList[answersList.findIndex(item => item.questionId === question.id)].answer))?
              <span onMouseEnter={()=>handleValue((value))}  onClick={()=>ansNPSInput((value).toString(),question)} key={index} 
                style={{background:NPSColor(question,surveyLanguageCode).color}} 
                className="bg-gray-100 rounded-md md:p-4 md:py-4 p-4 py-2 text-white  flex items-center justify-center  hover:bg-red-400  font-medium  cursor-pointer   px-3">
                {value}
              </span>
            :
            <span onMouseEnter={()=>handleValue((value))}  onClick={()=>ansNPSInput((value).toString(),question)} key={index} 
             className="bg-gray-100 rounded-md md:p-4 md:py-4 p-4 py-2 flex items-center justify-center  hover:bg-red-500 hover:text-white font-medium  cursor-pointer  px-3">
            {value}
              </span>
            }
            </>
            }
            </>
            )}
            
          </div>
          <div style={{background:NPSColor(question,surveyLanguageCode).color}} 
          className="bg-red-500 text-white text-center mb-2 rounded-sm py-1 mx-2">{NPSColor(question,surveyLanguageCode).name}</div>
          {/* <div className="flex justify-between font-medium text-sm"><p>Not likely</p> <p>Very likely</p></div> */}
          
          
    </>
  );}